import React from "react";
import { Box, Select, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import Donate from "./Donate";
import AdminBadge from "./AdminBadge";
import { localizedPath } from "../utils/localizedRoutes";

export default function AppHeader({ i18n }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
    // jeśli strona ma wersję w wybranym języku (np. /uk/karta-pobytu -> /karta-pobytu), przechodzimy na nią
    const target = localizedPath(location.pathname, e.target.value);
    if (target && target !== location.pathname) navigate(target + location.search);
  };

  // normalizacja: pl-PL -> pl
  const currentLang = i18n.language?.split("-")[0] || "pl";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
        px: 1,
        py: 0.5,
        mb: 0.25,
        backgroundColor: "background.paper",
        fontSize: "0.875rem",
      }}
    >
      <AdminBadge />

      <PrivacyPolicy sx={{ cursor: "pointer", fontSize: "0.875rem" }} />

      {/*<Donate paymentLink={paymentLink} />*/}

      <Select
        value={currentLang}
        onChange={handleLanguageChange}
        size="small"
        displayEmpty
        sx={{
          fontSize: "0.875rem",
          height: 28,
          "& .MuiSelect-select": {
            py: 0.5,
          },
        }}
      >
        <MenuItem value="pl">PL</MenuItem>
        <MenuItem value="en">EN</MenuItem>
        <MenuItem value="de">DE</MenuItem>
        <MenuItem value="es">ES</MenuItem>
        <MenuItem value="fr">FR</MenuItem>
        <MenuItem value="ua">UA</MenuItem>
      </Select>
    </Box>
  );
}
